import React, { useEffect, useRef, useState } from 'react';
import Modal from '@tencent/dui/lib/components/Modal';
import Radio from '@tencent/dui/lib/components/Radio';
import i18n from '@i18next/i18n';
import PageRange from '../range';
import { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { transaction } from '@src/js/utils';
import { DialogProps, QUICK_TOOL_AID_FEATURE } from '..';
import { showVipLinktext } from '@src/js/common/ark-extensions/dc-components/vip-linktext';
import { IPictureModel } from '@src/slide/domain/ui-model/element-modeles/Interface/picture-model.interface';
import { TaskPriority } from '@src/slide/infrastructure/module/dependent/taskManager';
import Loading from '@tencent/dui/lib/components/Loading';
import { isUiModelIsAttachment } from '@src/slide/domain/ui-model/elements/element-judge';
import { isLateXModel } from '@src/slide/application/service/addon/utils';
import { LINE_NUMBER } from '@src/slide/application/service/element-auto-layout-service';
import style from './style.less';
import { NumberInput } from '@tencent/wb-ext-form';

const apprec = 'batsetpiclay';


type IPicturePosDialog = React.FC<DialogProps>;
const PicturePosDialog: IPicturePosDialog = (props: DialogProps) => {
    const {
        visible, onClose, onOk, position, services,
    } = props;
    const [slideList, setSlideList] = useState<ISlideModel[]>();
    const [tilingType, setTilingType] = useState(LINE_NUMBER.SINGLE);
    const [mutiLineNumber, setMutiLineNumber] = useState(3);
    const [realNumber, setRealNumber] = useState(1);

    const getPicArr = (slide: ISlideModel): IPictureModel[] => slide.children
        .filter(child => (child.type === UIModelType.IMAGE
           && !child.rootGroupModel && !isUiModelIsAttachment(child) && !isLateXModel(child))) as IPictureModel[];

    const handleOk = () => {
        if (!onOk(apprec, i18n.t('批量图片布局')) || !slideList) {
            return;
        }
        const loading = Loading.show({ tip: i18n.t('加载中...') });
        const timeout = setTimeout(async () => {
            await Promise.all(slideList?.map(async (slide) => {
                !slide.childrenConverted && await slide.startConvertChildrenTask(TaskPriority.HIGH);
            }));
            transaction(() => {
                slideList?.forEach((slide) => {
                    const picArr = getPicArr(slide);
                    if (!picArr.length) return;
                    services.elementAutoLayoutService.layout(
                        picArr,
                        slide.width,
                        slide.height,
                        realNumber,
                    );
                });
            });
            loading.close();
            clearTimeout(timeout);
            onClose();
        }, 0);
    };

    const vipLinkRef = useRef(null);
    useEffect(() => {
        showVipLinktext({
            ref: vipLinkRef.current,
            name: i18n.t('批量图片布局'),
            feature: QUICK_TOOL_AID_FEATURE,
            position,
            apprec,
            anchor: 'PPT-TOOLS',
        });
    }, [vipLinkRef.current]);

    const getSketchMap = (childNum: number, childHeight: number, paddingVer: number, paddingHor: number) => <div
        style={{ padding: `${paddingHor}px ${paddingVer}px` }}
        className={style['sketch-map-wrapper']}>
        {new Array(childNum).fill(<div
            style={{ height: `${childHeight}px` }}
            className={style['sketch-map-child']}>
        </div>)}
    </div>;

    const currentSelectPicLength = slideList?.reduce((length, slide) => length + getPicArr(slide).length, 0);

    return (
        <Modal
            title={i18n.t('批量图片布局')}
            visible={visible}
            onClose={onClose}
            onCancel={onClose}
            className={style['muti-pic-pos-dialog']}
            onOk={handleOk}
        >
            <div style={{ width: '100%', marginBottom: '10px' }} ref={vipLinkRef}></div>
            <div className={style['select-number-tips']}>
                {i18n.t('共选择{0}个图片', { 0: currentSelectPicLength })}
            </div>
            <div style={{ margin: '20px 0px', width: '100%' }}>
                <Radio.Group
                    style={{ display: 'flex', justifyContent: 'space-between' }}
                    onChange={(value) => {
                        setTilingType(value);
                        setRealNumber(value === LINE_NUMBER.MUITI ? mutiLineNumber : value);
                    }}
                    defaultValue={LINE_NUMBER.SINGLE}>
                    <Radio value={LINE_NUMBER.SINGLE}>
                        <div className={style['lable-wrapper']}>{i18n.t('单行平铺')}</div>
                        { getSketchMap(4, 17, 5, 0) }
                    </Radio>
                    <Radio value={LINE_NUMBER.DOUBLE}>
                        <div className={style['lable-wrapper']}>{i18n.t('双行平铺')}</div>
                        { getSketchMap(6, 17, 16, 18) }
                    </Radio>
                    <Radio
                        value={LINE_NUMBER.MUITI}
                        labelClickable={false}
                        labelClassName={style['muti-lable-wrapper']}
                    >
                        <div className={style['lable-wrapper']}>
                            <NumberInput
                                value={(realNumber >= 3 ? realNumber : mutiLineNumber).toString()}
                                defaultValue={3}
                                disabled={tilingType !== LINE_NUMBER.MUITI}
                                step={1}
                                max={7}
                                min={3}
                                onChange={(value) => {
                                    setRealNumber(Number(value));
                                    setMutiLineNumber(Number(value));
                                }}
                                style={{
                                    width: '40px',
                                    height: '24px',
                                    display: 'inline-block',
                                    marginRight: '8px',
                                }}
                            >
                            </NumberInput>{i18n.t('行平铺')}</div>
                        { getSketchMap(9, 14, 16, 13) }
                    </Radio>
                </Radio.Group>
            </div>
            <PageRange
                needGetSelectModels={true}
                onCheckStateChange={list => setSlideList(list)}
                services={{
                    masterLayoutEditService: services.masterLayoutEditService,
                    selectionService: services.selectionService,
                }}>
            </PageRange>
        </Modal>
    );
};

export default PicturePosDialog;
